module.exports = __webpack_public_path__ + "img/logo_sample.ded41405.png";